/*
  Dehde home 10x – builder C behaviour (SPEC §3 blocks 12, 13, 15, 16; cross-section contract §1.5).
  Loaded with `defer` by dehde-home-row and dehde-home-contract. Every instance prints its own <script> tag and
  the browser runs each copy, so the file guards itself and binds ONE set of document-level listeners that
  serve any number of rows / contract bands (event delegation, no per-instance init).

  1. Product rows [data-dehde-hc-row]: prev/next buttons scroll the rail by one card; buttons are disabled at
     the ends (state refreshed on scroll through rAF). One layout read per click. No autoplay, no timers.
  2. Contract band [data-dehde-hc-contract]: stepper (clamped 1..max), WhatsApp link rebuilt from the message
     template on every change ([tipo], [quantita]).
  3. Sync from the seats tool (builder A, assets/dehde-home-a.js): `dehde-home:plan` on document with
     detail { space, venue, seats, threshold }. venue → «Tipo di locale» when that option exists;
     seats ≥ threshold → «Quantità indicativa» = seats. The listener is registered synchronously at parse time
     so an initial event dispatched by A on DOMContentLoaded is not missed.
*/
(function () {
  if (window.__dehdeHomeC) return;
  window.__dehdeHomeC = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1 · rows ---------- */
  function railOf(el) {
    var root = el.closest('[data-dehde-hc-row]');
    return root ? { root: root, rail: root.querySelector('[data-hc-rail]') } : null;
  }

  function updateArrows(root, rail) {
    var prev = root.querySelector('[data-hc-prev]');
    var next = root.querySelector('[data-hc-next]');
    if (!prev || !next || !rail) return;
    var max = rail.scrollWidth - rail.clientWidth;
    var x = rail.scrollLeft;
    prev.disabled = x <= 2;
    next.disabled = x >= max - 2;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hc-prev], [data-hc-next]');
    if (!btn) return;
    var r = railOf(btn);
    if (!r || !r.rail) return;
    var item = r.rail.querySelector('.dehde-hc-rail_item');
    var gap = parseFloat(getComputedStyle(r.rail).columnGap) || 0;
    var step = item ? item.getBoundingClientRect().width + gap : r.rail.clientWidth;
    var dir = btn.hasAttribute('data-hc-prev') ? -1 : 1;
    r.rail.scrollBy({ left: dir * step, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  var pending = new Set();
  var raf = 0;
  document.addEventListener('scroll', function (e) {
    var rail = e.target;
    if (!rail || !rail.matches || !rail.matches('[data-hc-rail]')) return;
    pending.add(rail);
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      pending.forEach(function (el) {
        var root = el.closest('[data-dehde-hc-row]');
        if (root) updateArrows(root, el);
      });
      pending.clear();
    });
  }, { capture: true, passive: true }); // scroll does not bubble: capture on document

  function initRows() {
    document.querySelectorAll('[data-dehde-hc-row]').forEach(function (root) {
      updateArrows(root, root.querySelector('[data-hc-rail]'));
    });
  }

  // viewport changes move the ends of the rail (3 → 5 cards): refresh once per frame
  var resizeRaf = 0;
  window.addEventListener('resize', function () {
    if (resizeRaf) return;
    resizeRaf = requestAnimationFrame(function () { resizeRaf = 0; initRows(); });
  }, { passive: true });

  /* ---------- 2 · contract band ---------- */
  function clampQty(input) {
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 9999;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    return Math.min(max, Math.max(min, v));
  }

  function refreshContract(root) {
    var card = root.querySelector('[data-hc-wa-template]');
    var select = root.querySelector('[data-hc-tipo]');
    var input = root.querySelector('[data-hc-qta]');
    if (!card || !select || !input) return;
    var qty = clampQty(input);
    var minus = root.querySelector('[data-hc-step="-1"]');
    if (minus) minus.disabled = qty <= (parseInt(input.min, 10) || 1);
    var wa = root.querySelector('.dehde-hc-ct_wa');
    if (!wa) return;
    var number = (card.getAttribute('data-hc-wa-number') || '').replace(/[^\d]/g, '');
    var msg = (card.getAttribute('data-hc-wa-template') || '')
      .split('[tipo]').join(select.value)
      .split('[quantita]').join(String(qty));
    // encodeURIComponent writes spaces as %20, like snippets/dehde-wa-button.liquid
    wa.href = 'https://wa.me/' + number + (msg ? '?text=' + encodeURIComponent(msg) : '');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dehde-hc-contract] [data-hc-step]');
    if (!btn) return;
    var root = btn.closest('[data-dehde-hc-contract]');
    var input = root.querySelector('[data-hc-qta]');
    if (!input) return;
    input.value = clampQty(input) + (parseInt(btn.getAttribute('data-hc-step'), 10) || 0);
    input.value = clampQty(input);
    refreshContract(root);
  });

  function onContractInput(e) {
    var el = e.target;
    if (!el.closest) return;
    var root = el.closest('[data-dehde-hc-contract]');
    if (!root) return;
    if (el.matches('[data-hc-qta]') && e.type === 'change') el.value = clampQty(el);
    if (el.matches('[data-hc-tipo], [data-hc-qta]')) refreshContract(root);
  }
  document.addEventListener('input', onContractInput);
  document.addEventListener('change', onContractInput);

  /* ---------- 3 · sync from the seats tool (builder A) ---------- */
  var lastPlan = null;

  function applyPlan(detail) {
    if (!detail) return;
    document.querySelectorAll('[data-dehde-hc-contract]').forEach(function (root) {
      var select = root.querySelector('[data-hc-tipo]');
      var input = root.querySelector('[data-hc-qta]');
      if (select && detail.venue) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === detail.venue) { select.selectedIndex = i; break; }
        }
      }
      var seats = parseInt(detail.seats, 10);
      var threshold = parseInt(detail.threshold, 10);
      if (input && !isNaN(seats) && !isNaN(threshold) && seats >= threshold) {
        input.value = seats;
        input.value = clampQty(input);
      }
      refreshContract(root);
    });
  }

  document.addEventListener('dehde-home:plan', function (e) {
    lastPlan = e.detail;
    // the band may be later in the DOM than the tool; before DOMContentLoaded it is applied on ready
    if (document.readyState !== 'loading') applyPlan(lastPlan);
  });

  function ready() {
    initRows();
    document.querySelectorAll('[data-dehde-hc-contract]').forEach(refreshContract);
    // The seats tool (dehde-home-a.js) is earlier in the page, so its deferred script usually runs first and its
    // initial 'dehde-home:plan' event fires before this listener exists. It also stores the plan on its root in
    // data-plan: recover it from there so the band starts from the tool's default (Casa), not its own.
    if (!lastPlan) {
      var t = document.querySelector('[data-dehde-home-tool][data-plan]');
      if (t) { try { lastPlan = JSON.parse(t.getAttribute('data-plan')); } catch (e) {} }
    }
    if (lastPlan) applyPlan(lastPlan);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  // Theme editor: sections re-rendered in place need their arrow state again
  document.addEventListener('shopify:section:load', ready);
})();
